import React, { useState,useContext } from 'react';
import './ShippingForm.css';
import { ShopContext } from '../../Context/ShopContext';

function ShippingForm() {
  const { getTotalCartAmount } = useContext(ShopContext);
  const [amount] = useState(getTotalCartAmount());

  const handlePayment = async (e) => {
    e.preventDefault();

    const orderDetails = {
      amount: amount, // Amount in paise
    };

    // Call the backend to create an order
    const response = await fetch('http://localhost:4000/create-order', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(orderDetails),
    });

    if (response.ok) {
      const data = await response.json(); // Get the order details
      console.log('Order created:', data);

      // Proceed with Razorpay payment integration
      const options = {
        key: 'rzp_test_KkdsDipQlMl5uQ', // Your Razorpay key ID
        amount: data.amount, // Amount is in paise
        currency: 'INR',
        name: 'ShoesStore', // Your company name
        description: 'Test Transaction', // Transaction description
        order_id: data.id, // The order ID generated by Razorpay
        handler: function (response) {
          alert(`Payment successful! Payment ID: ${response.razorpay_payment_id}`);
          // Optionally, you can send the payment information to your server for processing
        },
        prefill: {
          name: '', // Prefill the customer's name
          email: '', // Prefill the customer's email
          contact: '', // Prefill the customer's contact number
        },
        notes: {
          address: '', // Optional: Additional notes
        },
        theme: {
          color: '#F37254', // Customize the theme color
        },
      };

      const razorpay = new window.Razorpay(options);
      razorpay.open(); // Open the Razorpay checkout
    } else {
      console.error('Failed to create order');
    }
  };

  return (
    <div className="form-container">
      <h2>Enter your shipping address</h2>
      <form onSubmit={handlePayment}>
        <label>Email</label>
        <input type="email" name="email" required />

        <label>Country</label>
        <select name="country" required>
          <option value="India">India</option>
          <option value="USA">USA</option>
        </select>

        <label>Full name</label>
        <input type="text" name="fullName" required />

        <label>Street address</label>
        <input type="text" name="streetAddress" required />

        <label>City</label>
        <input type="text" name="city" required />

        <button type="submit">Continue to payment</button>
      </form>
    </div>
  );
}

export default ShippingForm;
